module.exports = __webpack_public_path__ + "img/wxPublic_top.2c58f4a9.png";